// extracted by mini-css-extract-plugin
module.exports = {"floatReviewFilter":"SA_A_D5"};